import { ThemeProvider } from '@mui/system';
import { StylesProvider } from '@mui/styles';
import React, { useState } from 'react';
import { themeCreator } from './base';

export const ThemeContext = React.createContext((themeName: string): void => {});

const ThemeProviderWrapper: React.FC = (props) => {
    const curThemeName = localStorage.getItem('appTheme') || 'PortrDefaultTheme';
    const [themeName, _setThemeName] = useState(curThemeName);
    const theme = themeCreator(themeName);

    const setThemeName = (themeName: string): void => {
        localStorage.setItem('appTheme', themeName);
        _setThemeName(themeName);
    };

    return (
        <StylesProvider injectFirst>
            <ThemeContext.Provider value={setThemeName}>
                <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
            </ThemeContext.Provider>
        </StylesProvider>
    );
};

export default ThemeProviderWrapper;
